import { useQuery } from "@tanstack/react-query";

import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function drawdownQueryOptions(
  client: ApiClient,
  filters: AnalyticsFilters = {},
) {
  return {
    queryKey: [...ANALYTICS_QUERY_KEY, "drawdown", filters],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/drawdown", {
        params: { query: toAnalyticsQuery(filters) },
      });
      if (error !== undefined) {
        throw new Error("Failed to load drawdown");
      }
      return data;
    },
  };
}

export function useDrawdown(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery(drawdownQueryOptions(client, filters));
}
